module.exports = __webpack_public_path__ + "assets/img/panasenko.5a439ad2.webp";